export const getImages = (language) => [
    {
        src: "/images/pic2.png",
        title: language === "English" ? "Gothic Reverie" : "Reverie Gótica",
        description:
            language === "English"
                ? "Step into the haunting beauty of a gothic cathedral, where mystery and sacred architecture intertwine. This piece explores the allure of the unknown, blending intricate details with a touch of magic."
                : "Sumérgete en la belleza inquietante de una catedral gótica, donde el misterio y la arquitectura sagrada se entrelazan. Esta pieza explora el encanto de lo desconocido, combinando detalles intrincados con un toque de magia.",
        link: "/image1-details",
    },
    {
        src: "/images/digital1.jpg",
        title: language === "English" ? "Ethereal Journey" : "Viaje Etéreo",
        description:
            language === "English"
                ? "A mesmerizing depiction of light and nature in harmony, this artwork showcases vibrant, swirling colors that draw you into an otherworldly landscape. It’s a celebration of transformation and the beauty of change."
                : "Una representación fascinante de la luz y la naturaleza en armonía, esta obra de arte muestra colores vibrantes y arremolinados que te atraen a un paisaje de otro mundo. Es una celebración de la transformación y la belleza del cambio.",
        link: "/image2-details",
    },
    {
        src: "/images/digital2.jpg",
        title: language === "English" ? "Inner Reflection" : "Reflexión Interior",
        description:
            language === "English"
                ? "A bold portrayal of self-discovery, this expressive piece captures the emotion and complexity of introspection. The striking contrast of light and shadow evokes a deep sense of connection to one’s inner world."
                : "Una representación audaz del autodescubrimiento, esta pieza expresiva captura la emoción y la complejidad de la introspección. El marcado contraste de luz y sombra evoca una profunda conexión con el mundo interior de uno.",
        link: "/image3-details",
    },
];

export const getPortfolioImages = (language) => [
    {
        src: "/images/portfolio/FA46A249-4AB4-4C6C-94C0-F49282310212.jpg",
        title:
            language === "English"
                ? "Surreal Landscape"
                : "Paisaje Surrealista",
        description:
            language === "English"
                ? "A dreamy, layered environment exploring light and geometry."
                : "Un entorno onírico y estratificado que explora la luz y la geometría.",
        alt: "Artwork 1",
    },
    {
        src: "/images/portfolio/IMG_0366.jpg",
        title:
            language === "English"
                ? "Urban Mood"
                : "Ambiente Urbano",
        description:
            language === "English"
                ? "Dark tones, moody lighting, and street shadows."
                : "Tonos oscuros, iluminación melancólica y sombras urbanas.",
        alt: "Artwork 2",
    },
    {
        src: "/images/portfolio/IMG_4432.jpg",
        title:
            language === "English"
                ? "Mystic Energy"
                : "Energía Mística",
        description:
            language === "English"
                ? "A pulse of color and form representing unseen forces."
                : "Un pulso de color y forma que representa fuerzas invisibles.",
        alt: "Artwork 3",
    },
    {
        src: "/images/portfolio/IMG_20200328_011057.jpg",
        title:
            language === "English"
                ? "Organic Motion"
                : "Movimiento Orgánico",
        description:
            language === "English"
                ? "Soft, flowing brushwork exploring natural motion and chaos."
                : "Trazos suaves y fluidos que exploran el movimiento natural y el caos.",
        alt: "Artwork 4",
    },
    {
        src: "/images/portfolio/IMG_20201204_163609.jpg",
        title:
            language === "English"
                ? "Fragmented Light"
                : "Luz Fragmentada",
        description:
            language === "English"
                ? "Prisms of color that break across abstract shapes."
                : "Prismas de color que atraviesan formas abstractas.",
        alt: "Artwork 5",
    },
    {
        src: "/images/portfolio/IMG_20210103_220926.jpg",
        title:
            language === "English"
                ? "Electric Horizon"
                : "Horizonte Eléctrico",
        description:
            language === "English"
                ? "Futuristic vibes meet dreamy landscapes."
                : "Vibraciones futuristas se encuentran con paisajes oníricos.",
        alt: "Artwork 6",
    },
    {
        src: "/images/portfolio/IMG_20210113_200741.jpg",
        title:
            language === "English"
                ? "Midnight Bloom"
                : "Floración Nocturna",
        description:
            language === "English"
                ? "A deep color study with floral undertones."
                : "Un estudio de color profundo con matices florales.",
        alt: "Artwork 7",
    },
    {
        src: "/images/digital2.jpg",
        title:
            language === "English"
                ? "Inner Reflection"
                : "Reflexión Interior",
        description:
            language === "English"
                ? "A bold portrayal of self-discovery, this expressive piece captures the emotion and complexity of introspection. The striking contrast of light and shadow evokes a deep sense of connection to one’s inner world."
                : "Una representación audaz del autodescubrimiento, esta pieza expresiva captura la emoción y la complejidad de la introspección. El marcado contraste de luz y sombra evoca una profunda conexión con el mundo interior de uno.",
        alt: "Inner Reflection Artwork",
        link: "/image3-details",
    },
];
